import React, {createContext, useContext} from 'react';
import {useDispatch} from "react-redux";
import {FormikProvider, useFormik} from 'formik';
import {useTransfersByAgentContext} from './TransfersByAgentContext';
import * as actions from "../_redux/transfersByAgentActions";

const UpdateIncomeContext = createContext({});

export const useUpdateIncomeContext = () => useContext(UpdateIncomeContext);

export const UpdateIncomeProvider = ({children}) => {
  const dispatch = useDispatch();
  const {agentId, tamalData, getTransfersByAgent} = useTransfersByAgentContext();
  const formik = useFormik({
    initialValues: {
      avgIncome: tamalData.expectedAvgIncome || '',
      realAvgIncome: tamalData.realAvgIncome || '',
    },
    onSubmit: () => {
    },
    enableReinitialize: true
  });
  const update = () => {
    dispatch(actions.updateAvgIncome({
      agentID: parseInt(agentId) || 0,
      avgIncome: formik.values.avgIncome,
    }));
    getTransfersByAgent();
  };

  return (
    <UpdateIncomeContext.Provider value={{formik, update}}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </UpdateIncomeContext.Provider>
  );
};